import { SUBCATEGORY_BY_FILE_TYPE, type Asset } from '@odo/shared-ui';

// The dashboard STL step tags uploads with `metadata.stlType`.
const DASHBOARD_STL_TYPE_LABELS: Readonly<Record<string, string>> = {
    upper: 'Upper jaw',
    lower: 'Lower jaw'
};

function stringMeta(asset: Asset, key: string): string | null {
    const value = asset.metadata?.[key];
    return typeof value === 'string' && value.length > 0 ? value : null;
}

function subcategoryLabel(asset: Asset, fileType: 'RADIOGRAPH' | 'STL'): string | null {
    const config = SUBCATEGORY_BY_FILE_TYPE[fileType];
    const value = config ? stringMeta(asset, config.metaKey) : null;
    if (!config || !value) return null;
    return config.options.find((o) => o.value === value)?.label ?? null;
}

export function radiographCaption(asset: Asset): string | null {
    return subcategoryLabel(asset, 'RADIOGRAPH');
}

export function stlCaption(asset: Asset): string | null {
    const stlType = stringMeta(asset, 'stlType');
    if (stlType) return DASHBOARD_STL_TYPE_LABELS[stlType] ?? stlType;
    return subcategoryLabel(asset, 'STL');
}
